// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__dPmuM","label":"styles_label__rDJHc","value":"styles_value__76FOP","skeleton-animation":"styles_skeleton-animation__wHjIe"};